import React, { createClass, PropTypes } from 'react';
import reactUpdate from 'react-addons-update';
import { List, ListItem, RaisedButton, Divider, Avatar } from 'material-ui';
import ClickAwayListener from 'material-ui/internal/ClickAwayListener';
import moment from 'moment';
import ArrowBox from '../../tc-ui/arrow-box';

import { connect } from 'react-redux';
import getClassNames from 'classnames';
import blurrySrc from '../../../../www/images/blurry.jpg';
import { openUpgradeFrom } from '../../../stores/ui/components/upgrade/upgrade-actions';
import LockIcon from 'material-ui/svg-icons/action/lock';
import WallWrapper from '../../wall/wrapper';

const ViewLink = createClass({

  propTypes: {
    history: PropTypes.object,
    dispatch: PropTypes.func,
    triggerSnackBarMessage: PropTypes.func,
    profile: PropTypes.object,
    updateUpgradeSource: PropTypes.func,
    profileToShow: PropTypes.object,
    className: PropTypes.string,
    user: PropTypes.object,
    openUpgradeFrom: PropTypes.func,
  },

  getInitialState() {
    return {
      localComponentState: {
        open: false,
      },
    };
  },

  setLocalComponentState(update) {
    this.setState({ localComponentState: reactUpdate(this.state.localComponentState, { $merge: update }) });
  },

  componentClickAway() {
    this.setLocalComponentState({ open: false });
  },

  handleOnClick() {
    this.setLocalComponentState({ open: !this.state.localComponentState.open });
  },

  openProfile(companyId) {
    const { history } = this.props;
    history.push(`/company/${companyId}`);
  },

  upgradePlanClicked() {
    this.setLocalComponentState({ open: false });
    this.props.openUpgradeFrom('profileViews');
  },

  render() {
    const { profileToShow, history } = this.props;
    const classes = getClassNames('view-link', this.props.className, {
      'is-closed': !this.state.localComponentState.open,
    });
    let numberOfViews;
    let viewerLists;
    let arrowBoxContent;
    if (profileToShow.profileViews) {
      numberOfViews = profileToShow.profileViews.length;
      viewerLists = profileToShow.profileViews.map((view, index) => {
        const primaryText = <div className="div-link" style={{ fontSize: '13px' }} onClick={() => this.openProfile(view.companyId)}>{view.companyName}</div>;
        const secondaryText = (
          <div style={{ fontSize: '11px' }}>
            {
              moment(new Date(+view.timeViewed)).isValid() ?
                moment(new Date(+view.timeViewed)).format('l, h:mm a')
                : moment(new Date(view.timeViewed)).format('l, h:mm a')
            }
          </div>
        );
        let listDivider;
        let rightIcon;
        let rightIconButton;
        if (index !== 0) listDivider = <Divider inset />;
        return (
              <div key={index}>
                <ListItem
                  primaryText={primaryText}
                  secondaryText={secondaryText}
                  rightIconButton={rightIconButton}
                  rightIcon={rightIcon}
                  leftAvatar={<Avatar src={view.profileImageUrl}/>}
                  disabled
                />
                {listDivider}
              </div>);
      });
      viewerLists.reverse();
    }

    let overflow;
    if (this.props.user.company.plan === 'unlimited' || this.props.user.company.plan === 'connected') {
      if (viewerLists.length) {
        arrowBoxContent = (<List style={{ textAlign: 'left', margin: '0px' }}>
                            {viewerLists}
                          </List>);
      } else {
        arrowBoxContent = (<div style={{ width: '90%', margin: '20px auto', textAlign: 'center', fontSize: '16px', color: 'grey' }}>
                            <div style={{ margin: '45px 0 15px 0' }}>{"Seems a bit quiet here."}</div>
                            <div style={{ marginBottom: '20px' }}>{"Start inviting more partners!"}</div>
                            <RaisedButton primary label="+ add connections" onTouchTap={() => history.push('/connections/add-connections')}/>
                            <div style={{ margin: '10px auto' }}>OR</div>
                            <RaisedButton secondary label="+ find new partners" onTouchTap={() => history.push('/partner-finder/results')}/>
                          </div>);
      }
      overflow = 'scroll';
    } else {
      arrowBoxContent = (
        <div style={{ width: '90%', margin: '20px auto', textAlign: 'center' }}>
          <h4>Upgrade to see who has viewed your Profile</h4>
          <WallWrapper hideOnSkip blocker slug="upgrade-pf-mktg-prfle" amazonOrange lockIcon>
            <RaisedButton
              primary
              label="upgrade my plan"
              onClick={this.upgradePlanClicked}
            />
          </WallWrapper>
          <div><img src={blurrySrc} /></div>
        </div>);
      overflow = 'hidden';
    }
    return (
      <div className={classes}>
        <div className="views-info">
          <div className="div-link" onClick={this.handleOnClick}>
            <div style={{ display: 'inline-block', cursor: 'pointer', fontSize: '20px', lineHeight: '40px', marginRight: '3px' }}>
              <strong>
                {numberOfViews}
              </strong>
            </div>
            <div style={{ display: 'inline-block', marginLeft: '4px' }}>Profile Views</div>
          </div>
        </div>
        <ClickAwayListener onClickAway={this.componentClickAway}>
          <div className="view-link-container">
            <ArrowBox
              boxStyle={{ marginTop: '12px', marginLeft: '-8px', width: '285px' }}
              innerBoxStyle={{ paddingRight: '20px', height: '300px', overflow }}
            >
              {arrowBoxContent}
            </ArrowBox>
          </div>
        </ClickAwayListener>
      </div>
    );
  },
});

export default connect(null, { openUpgradeFrom })(ViewLink);



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/view-link.jsx